import { useEffect } from "react";
import {usePrevious} from "../../../misc/helperHooks";

export function useMaterialsStepsAutoMove({
                                            wizardSteps,
                                            wizardActiveStep,
                                            scrollElementRef,
                                          }) {
  // Auto-center the active step whenever it changes (custom 500ms ease-in-out)

  const currentStep = usePrevious(wizardActiveStep);

  useEffect(() => {
    const container = scrollElementRef.current;
    if (!container) return;

    const activeEl = container.querySelector(`[data-step="${wizardActiveStep}"]`);
    if (!activeEl) return;

    if (currentStep === wizardActiveStep) {
      return // prevent re-centering on item click
    }
    // console.log("wizardSteps.length", wizardSteps.length, "//", wizardSteps.length * 78, "//", container.clientWidth);
    if ((wizardSteps.length * 78) < container.clientWidth) { // don't do anything for small wizards
      return
    }

    // When close to the end, skip centering and just scroll to the far right.
    // Centering near the end undershoots (not enough steps on the right to fill
    // the left half of the viewport), which causes a visible jump.
    const nearEnd = wizardSteps.length - wizardActiveStep <= 4;
    const raw = activeEl.offsetLeft - container.clientWidth / 2 + activeEl.offsetWidth / 2;
    const target = nearEnd
      ? container.scrollWidth - container.clientWidth
      : Math.max(0, Math.min(raw, container.scrollWidth - container.clientWidth));

    const start = container.scrollLeft;
    const distance = target - start;
    if (Math.abs(distance) < 1) return;           // already there, skip

    const DURATION = 500; // ms
    const ease = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; // ease-in-out

    const startTime = performance.now();
    let raf;
    let cancelled = false;

    // Expose a cancel hook so bodySwipable can interrupt when the user drags
    container._cancelAutoScroll = () => {
      cancelled = true;
    };

    const tick = (now) => {
      if (cancelled) return;
      const progress = Math.min((now - startTime) / DURATION, 1);
      container.scrollLeft = start + distance * ease(progress);
      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        container._cancelAutoScroll = null;
      }
    };

    raf = requestAnimationFrame(tick);

    // Cleanup: if wizardActiveStep changes again mid-flight, cancel the old animation
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
      container._cancelAutoScroll = null;
    };
  }, [wizardActiveStep, wizardSteps, scrollElementRef]);

  return null
}
